export default __webpack_public_path__ + "static/media/opt_pk_react_thumbnail.79124285.jpg";